export const CALENDAR_PICKER = {
  // CalendarPicker.tsx
  SELECT_CONTAINER: 'calendar-picker-select-container',
  SEARCH_INPUT: 'calendar-picker-search-input',
  SEARCH_ICON: 'calendar-picker-search-icon',
  CREATE_CALENDAR_BUTTON: 'calendar-picker-create-calendar-button',
  CREATE_CALENDAR_ICON: 'calendar-picker-create-calendar-icon',
  CREATE_CALENDAR_TEXT: 'calendar-picker-create-calendar-text'
} as const;
